import { modelOptions, prop, Severity } from '@typegoose/typegoose';
import mongoose from 'mongoose';
enum PATCH_STATUS {
  NOT_INSTALLED = 0,
  INSTALLED = 1,
  PENDING = 2,
  FAILED = 3,
}

enum PATCH_STATUS_ERROR_CODE {
  DOWNLOAD_FAILED = 0,
  NOT_APPLICABLE = 1,
  INSTALLATION_FAILED = 2,
  PENDING_REBOOT = 3,
  UNKNOWN = 4,
}

@modelOptions({
  schemaOptions: { collection: 'endpointsPatchesStatus' },
  options: { allowMixed: Severity.ALLOW, customName: 'endpointsPatchesStatus' },
})
export class EndpointPatchesStatusModel {
  @prop({ required: true })
  _id: mongoose.Types.ObjectId;

  @prop({ required: true })
  companyId: mongoose.Types.ObjectId;

  @prop({ required: true })
  endpointId: mongoose.Types.ObjectId;

  @prop({ required: true })
  patchId: string;

  @prop({ required: true, enum: PATCH_STATUS, type: mongoose.Schema.Types.Number })
  installationStatus: PATCH_STATUS;

  @prop({ required: true, default: null, enum: PATCH_STATUS_ERROR_CODE, type: mongoose.Schema.Types.Number })
  installationErrorCode: PATCH_STATUS_ERROR_CODE;
}
